import React from 'react';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Collapse from '@material-ui/core/Collapse';

import Map from '../../../Util/Map'
import NumberInput from '../../FormComponents/NumberInput'

export default class MapContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openMap: false,
            showNumberInput: false,
            selected_customType: '',
            selected_customId: '',
            selected_customHeight: '',
            drawBuilding: false,
            clearBuildings: false,
            drawFenceline: false,
            clearFencelines: false
        };

    }

    clearGeojson(name) {
        this.props.handleInputChange({
            'target': {
                'type': 'input',
                'name': name,
                'value': null
        }})
    }

    uploadShpFile(event) {
        let file = event.target.files[0];
        let name = event.target.name

        this.props.handleInputChange({
            'target': {
                'type': 'input',
                'name': name,
                'value': null
        }})

        window.loadshp({
            url: file, // path or your upload file
            encoding: 'big5', // default utf-8
            EPSG: 4326 // default 4326l
        }, function(geojson) {
            let counter = 0
            geojson.features.forEach(feature => {
                if (feature.properties && !(feature.properties._customPassthroughVariable)){
                    feature.properties._customType = name
                    feature.properties._customId = String(counter)
                    feature.properties._customHeight = 3
                    feature.properties._customPassthroughVariable = true

                    counter += 1
                }
            })

            this.props.handleInputChange({
                'target': {
                    'type': 'input',
                    'name': name,
                    'value': geojson
            }})

        }.bind(this))
    }

    setGeojsonInfo = (_customType, _customId, _customHeight) => {
        this.setState({
            selected_customType: _customType,
            selected_customId: _customId,
            selected_customHeight: _customHeight,
        })
    }

    handleGeojsonInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.type === 'radio' ? target.attributes.radioname.value : target.name;

        this.setState({
            [name]: value
        });

        let selected_customType = this.state.selected_customType
        let selected_customId = this.state.selected_customId

        if (selected_customType === 'fencelineGeojson' || selected_customType === 'buildingGeojson'){
            let geojson = this.props[selected_customType]

            geojson.features.forEach(feature => {
                if (feature.properties._customId === selected_customId){
                    feature.properties._customHeight = value
                }
            })

            this.props.handleInputChange({
                'target': {
                    'type': 'input',
                    'name': this.state[selected_customType],
                    'value': geojson
            }})
        } else if (selected_customType === 'drawnBuildings' || selected_customType === 'drawnFences'){
            let drawnArray = this.props[selected_customType]

            console.log(drawnArray)
            drawnArray.forEach(feature => {
                if (feature.properties._customId === selected_customId){
                    feature.properties._customHeight = value
                }
            })

            this.props.handleInputChange({
                'target': {
                    'type': 'input',
                    'name': this.state[selected_customType],
                    'value': drawnArray
            }})
        }
    }

    changeBoolean = (varName) => {
        let boolValue = this.state[varName]
        this.setState({[varName]: !boolValue})
    }

    setBoolean = (varName, boolValue) => {
        this.setState({[varName]: boolValue})
    }




    render() {
        const { classes } = this.props;

        return (
            <div className="form-input-container" >
                <p className={classNames(classes.margin)}>
                    Open the map below to upload building/fenceline shapefiles in WGS84 projection or
                    to draw buildings/fencelines on the map. Clicking a building will
                    allow you to change its height (the default value is 3 meters).
                    **Buildings/fencelines drawn on the map will take precedence over
                    uploaded shape files.
                </p>
                <Button
                    className={classNames(classes.marginLeft, classes.toggleMapButton)}
                    onClick={() => {this.setState({openMap: !this.state.openMap})}}
                    variant='outlined'
                    color="primary"
                > { this.state.openMap ? <span> Hide Map </span> : <span> Show Map </span> } </Button>

                <Collapse
                    in={this.state.openMap} timeout="auto"
                    className={classNames(classes.margin, classes.mapContainer)}
                    >
                    <div style={{height: '10px'}}></div>
                    <div style={{marginLeft: '20px'}}>
                        Facility = Green Dot <br></br>Sources = Yellow Dot
                    </div>
                    <div>
                        <Button
                            className={classNames(classes.margin, classes.plainWhiteButton)}
                            variant="outlined"
                            disabled={true}
                            color="default"
                            component="label"
                        > Upload Building File

                        </Button>

                        <Button
                            className={classNames(classes.margin, classes.plainWhiteButton)}
                            variant="outlined"
                            disabled={true}
                            color="default"
                            component="label"
                        > Upload Fenceline File

                        </Button>


                    </div>

                    <div>

                        <Button
                            className={classNames(classes.margin, classes.plainWhiteButton)}
                            variant="outlined"
                            color="default"
                            component="label"
                            onClick={() =>  {
                                this.changeBoolean('drawBuilding')
                                this.setBoolean('drawFenceline', false)
                            }}
                        > Draw Building </Button>

                        <Button
                            className={classNames(classes.margin, classes.plainWhiteButton)}
                            variant="outlined"
                            color="default"
                            component="label"
                            onClick={() =>  {
                                this.changeBoolean('drawFenceline')
                                this.setBoolean('drawBuilding', false)
                            }}
                        > Draw Fenceline </Button>

                        <Button
                            className={classNames(classes.margin, classes.clearPolygonButton)}
                            variant="outlined"
                            color="default"
                            component="label"
                            onClick={() => {
                                this.changeBoolean('clearBuildings')
                                this.changeBoolean('clearFencelines')
                            }}
                            > Clear Drawings </Button>
                    </div>


                    <Map
                        classes={classes}
                        facilityLat={this.props.latitude}
                        facilityLon={this.props.longitude}
                        facilitySource={this.props.source}
                        buildingGeojson={this.props.buildingGeojson}
                        fencelineGeojson={this.props.fencelineGeojson}
                        selectedCustomHeight={this.state.selected_customHeight}
                        drawBuilding={this.state.drawBuilding}
                        clearBuildings={this.state.clearBuildings}
                        drawFenceline={this.state.drawFenceline}
                        clearFencelines={this.state.clearFencelines}
                        drawnBuildings={this.props.drawnBuildings}
                        drawnFencelines={this.props.drawnFencelines}
                        handleInputChange={this.props.handleInputChange}
                        setGeojsonInfo={this.setGeojsonInfo}
                        changeBoolean={this.changeBoolean}
                        setBoolean={this.setBoolean} />

                    {this.state.showNumberInput && <NumberInput
                                                        classes={classes}
                                                        handleInputChange={this.handleGeojsonInputChange}
                                                        instructions='Enter the height for the selected item (meters).'
                                                        name='selected_customHeight'
                                                        value={this.state.selected_customHeight} />}

                </Collapse>
            </div>
        );
    }
}
